import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import {
  getAssignedRoles,
  getUserRoles,
  setAssignedStatus,
  setSelectedView,
} from "../../../store/action";
import "./sidebar.scss";
import { AppState } from "../../../../common/store/combinedReducer";
import { HomeIcon } from "@forge/common";
import dataManagement from "../../../../common/assets/data-management.svg";
import userManagement from "../../../../common/assets/user-management.svg";
import config, {
  REQUIRED_PERMISSIONS,
} from "../../../../common/authentication/config";
import _ from "lodash";

interface SidebarProps {
  isOpen: boolean;
  onClose: () => void;
  hideManagementTabs?: boolean;
  disableNavigation?: boolean;
}

const Sidebar: React.FC<SidebarProps> = ({
  isOpen,
  onClose,
  hideManagementTabs = false,
  disableNavigation = false,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [activeItem, setActiveItem] = useState("");

  useEffect(() => {
    if (location.pathname.includes("/userManagement")) {
      setActiveItem("User Management");
    } else if (location.pathname.includes("/dataManagement")) {
      setActiveItem("Data Management");
    } else if (
      location.pathname === "/dashboard" ||
      location.pathname.includes("/dashboard")
    ) {
      setActiveItem("Dashboard");
    } else {
      setActiveItem("");
    }
  }, [location.pathname]);
  const selectedView = useSelector((state: AppState) => {
    return state.reducer.selectedView;
  });
  const selectedPlant = useSelector((state: AppState) => {
    return state.reducer.selectedPlant;
  });
  const permissions = useSelector((state: AppState) => {
    return state.reducer.permissions;
  });
  const userRolesStatus = useSelector((state: AppState) => {
    return state.reducer.userRolesStatus;
  });
  const selectedTenant: any = useSelector((state: AppState) => {
    return state.reducer.selectedTenant;
  });
  const orgsDropDownData = useSelector((state: AppState) => {
    return state.reducer.orgsDropDownData;
  });

  const [showUserManagement, setShowUserManagement] = useState(false);
  const [showDataManagement, setShowDataManagement] = useState(false);

  useEffect(() => {
    const valuePermission: any = _.find(permissions, [
      "resources",
      selectedPlant,
    ]);
    if (
      valuePermission &&
      valuePermission?.permissions &&
      valuePermission.permissions.length > 0
    ) {
      const isHonAcaTenant = orgsDropDownData?.find(
        (data: any) => data.value === config.SITE_ID,
      );
      const hasUserManagement =
        REQUIRED_PERMISSIONS.CAN_VIEW_USER_MANAGEMENT.every((p: string) =>
          valuePermission.permissions.includes(p),
        );
      const hasDataManagement =
        REQUIRED_PERMISSIONS.TRANSFER_DATA_OR_FILES_IN_AND_OUT.every(
          (p: string) => valuePermission.permissions.includes(p),
        );
      setShowUserManagement(
        hasUserManagement && !isHonAcaTenant && !hideManagementTabs,
      );
      setShowDataManagement(
        hasDataManagement && !isHonAcaTenant && !hideManagementTabs,
      );
    } else {
      setShowUserManagement(false);
      setShowDataManagement(false);
    }
  }, [permissions, selectedPlant, orgsDropDownData, hideManagementTabs]);

  const menuItems = [
    {
      name: "Dashboard",
      icon: <HomeIcon className="nav-item-icon w-6 h-6 mb-1" />,
      view: "Dashboard",
      show: true,
    },
    {
      name: "User Management",
      icon: <img src={userManagement} alt="" className="nav-item-icon" />,
      view: "UserManagement",
      show: showUserManagement,
    },
    {
      name: "Data Management",
      icon: (
        <img src={dataManagement} alt="" className="data-management-icon" />
      ),
      view: "DataManagement",
      show: showDataManagement,
    },
  ];
  const handleNavigation = (item: any) => {
    setActiveItem(item.name);
    localStorage.setItem("activeTab", item.view);

    if (item.view === "Dashboard") {
      navigate(
        "/dashboard/?siteId=" + selectedPlant + "&tenantId=" + selectedTenant,
      ); // changes made here to pass refer for dashboard
    } else if (item.view === "UserManagement") {
      if (selectedPlant !== "") {
        if (userRolesStatus === 0) {
          dispatch(
            getUserRoles({
              authorization: localStorage.getItem("access_token"),
              siteId: selectedPlant,
              tenantId: selectedTenant,
            }),
          );
        }
        // if (assignedRolesStatus === 0) {
        dispatch(setAssignedStatus(0));
        dispatch(
          getAssignedRoles({
            authorization: localStorage.getItem("access_token"),
            siteId: selectedPlant,
            tenantId: selectedTenant,
          }),
        );
        // }
      }
      navigate("/dashboard/userManagement");
    } else if (item.view === "DataManagement") {
      navigate("/dashboard/dataManagement");
    } else {
      dispatch(setSelectedView({ selectedView: selectedView }));
    }

    onClose();
  };

  return (
    <>
      <div className={`sidebar ${isOpen ? "sidebar-open" : "sidebar-closed"}`}>
        <div className="sidebar-content">
          <div className="sidebar-header">
            <img src="/icon.png" alt="Digital Prime" className="sidebar-icon" />
            <span className="course-admin">Digital Prime Twin</span>
          </div>
          <nav className="sidebar-nav">
            {menuItems
              .filter((item) => item.show)
              .map((item) => (
                <div
                  key={item.name}
                  className={`nav-item ${
                    activeItem === item.name ? "nav-item-active" : ""
                  } ${disableNavigation && activeItem !== item.name ? "nav-item-disabled" : ""}`}
                  onClick={() => !disableNavigation && handleNavigation(item)}
                  style={{
                    cursor: disableNavigation && activeItem !== item.name ? "not-allowed" : "pointer",
                    opacity: disableNavigation && activeItem !== item.name ? 0.5 : 1,
                  }}
                >
                  <span className="nav-icon">{item.icon}</span>
                  <span className="nav-text">{item.name}</span>
                </div>
              ))}
          </nav>
          {/* <div className="sidebar-footer">
            <div
              className="footer-item"
              onClick={() => navigate("/dashboard")}
              style={{
                cursor:
                  location.pathname === "/dashboard" ? "default" : "pointer",
              }}
            >
              <span className="nav-icon mb-1">
                <HomeIcon className="nav-item-icon" />
              </span>
              <span className="nav-text">DIGITAL PRIME TWIN</span>
            </div>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default Sidebar;
